import styled from 'styled-components';

import { color } from '../../../../atoms/colors';
import { spacing } from '../../../../atoms/spacing';
import { font } from '../../../../atoms/typography';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[12]};
  padding: ${spacing[16]};
  border-radius: 5px;
  border: 1px solid ${color.darkBlue[25]};
  background: ${color.common.white};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06),
    0px 1px 3px 0px rgba(16, 24, 40, 0.1);
`;

export const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};

  .heading {
    ${font('text', 'lg', '500')}
    color: ${color.darkBlue[1000]};
  }
`;

export const Grid = styled.div`
  display: ${props => (props.length > 2 ? 'grid' : 'flex')};
  flex-direction: column;
  grid-template-columns: repeat(2, 1fr);
  gap: ${spacing[4]};

  .item {
    ${font('text', 'lg', '400')}
    color: ${color.darkBlue[600]};
  }
`;
